function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9534 15.457C19.9842 15.6354 20 15.8165 20 16C20 18.7614 16.4183 21 12 21C7.58172 21 4 18.7614 4 16C4 15.8165 4.01581 15.6354 4.04663 15.457C5.87458 17.6107 8.75701 19 12 19C15.2375 19 18.1157 17.6153 19.9433 15.4681L19.9534 15.457ZM19.9534 11.457C19.9842 11.6354 20 11.8165 20 12C20 14.7614 16.4183 17 12 17C7.58172 17 4 14.7614 4 12C4 11.8165 4.01581 11.6354 4.04663 11.457C5.87458 13.6107 8.75701 15 12 15C15.2375 15 18.1157 13.6153 19.9433 11.4681L19.9534 11.457ZM12 3C16.4183 3 20 5.23858 20 8C20 10.7614 16.4183 13 12 13C7.58172 13 4 10.7614 4 8C4 5.23858 7.58172 3 12 3Z",
  fill: "#FFD600"
});

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "assets/media/coins.16df8a0a.svg";
export { ForwardRef as ReactComponent };